/**
 * @generated SignedSource<<615a98fee2f3b784b5f0daf2f20ddb2c>>
 * @relayHash 53c09b481c3fedf1e2ab5e87303ad2db
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53c09b481c3fedf1e2ab5e87303ad2db

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deletePhysiotherapyPrescriptionInput = {
  id: string;
};
export type useChDeletePhysiotherapyMutation$variables = {
  input: Ch_deletePhysiotherapyPrescriptionInput;
};
export type useChDeletePhysiotherapyMutation$data = {
  readonly ch_deletePhysiotherapyPrescription: {
    readonly ch_PhysiotherapyPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeletePhysiotherapyMutation = {
  response: useChDeletePhysiotherapyMutation$data;
  variables: useChDeletePhysiotherapyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeletePhysiotherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePhysiotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deletePhysiotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PhysiotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PhysiotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeletePhysiotherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePhysiotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deletePhysiotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PhysiotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PhysiotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "53c09b481c3fedf1e2ab5e87303ad2db",
    "metadata": {},
    "name": "useChDeletePhysiotherapyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "33852bced5a93a0c0c90be504a45ed00";

export default node;
